namespace app.tarefas.minhasTarefas {

    import IDialogService = ng.material.IDialogService;

    export class UnAssignTagController {

        public cmd: UnAssigneeTagTasksCommand;

        /** @ngInject **/
        constructor(private $mdDialog: IDialogService,
            private minhasTarefasService: MinhasTarefasService,
            private tasks: ITask[], public tags: ITaskTag[]) {
            this.cmd = new UnAssigneeTagTasksCommand(tasks);
        }

        public unassigntagsTasks(): void {
            this.$mdDialog.hide(this.cmd);
        }

        public closeDialog(): void {
            this.$mdDialog.hide(null);
        }
    }

    angular
        .module("app.tarefas.minhas-tarefas")
        .controller("app.tarefas.minhas-tarefas.UnAssignTagController", UnAssignTagController);
}